export * from './dialog-yes-no.component';



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/dialog-yes-no/index.ts